import { render, staticRenderFns } from "./myhealthSLOne.vue?vue&type=template&id=1a2deebf&scoped=true&"
import script from "./myhealthSLOne.vue?vue&type=script&lang=js&"
export * from "./myhealthSLOne.vue?vue&type=script&lang=js&"
import style0 from "./myhealthSLOne.vue?vue&type=style&index=0&id=1a2deebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2deebf",
  null
  
)

export default component.exports